import { createContext } from 'react';
import { ContentfulEntry } from 'blades/widgetTypes';
import { IQuickstartMenu } from 'models/Quickstart/@types';

export interface QuickstartContextType {
  isOpen: boolean;
  quickStart: ContentfulEntry<IQuickstartMenu> | null;
  closeQuickstart: () => void;
}

const initialState: QuickstartContextType = {
  isOpen: false,
  quickStart: null,
  closeQuickstart: () => {},
};

export default createContext<QuickstartContextType>(initialState);
